import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  Renderer2,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs/internal/Subscription';
import { data_fields, data_item, data_type } from 'src/app/misc/interface/data';

import { DataView } from 'primeng/dataview';
import { MenuItem } from 'src/app/misc/interface/menu-item';
import { OrganizationUnit } from 'src/app/misc/interface/organization-unit';
import { GlobalConstants } from 'src/app/services/global-constants';
import { DataService } from 'src/app/services/data.service';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';
import { SerializeService } from 'src/app/services/serialize.service';
import { ExportService } from 'src/app/services/export.service';
import { TemplateFieldsService } from 'src/app/services/templete-fileds.service';
import { ConfirmEventType, ConfirmationService, Message } from 'primeng/api';
import { TranslatorPipe } from 'src/app/services/translator.pipe';
import { Messages } from 'primeng/messages';
import { query } from '@angular/animations';


@Component({
  selector: 'app-data-view',
  templateUrl: './data-view.component.html',
  styleUrls: ['./data-view.component.scss'],
})
export class DataViewComponent {
  currentRoute: any;
  skeleton = true
  translator:TranslatorPipe = new TranslatorPipe()

  @ViewChild('dv')
  dataView!: DataView;
  @Input() searchVal: string = '';
  @Input() colors: string[] = [
    '#04524d',
    '#138884',
    '#02afa9',
    '#1f798d',
    '#0a2438',
  ];
  breadcrumbs: MenuItem[] = [
    { label:  this.translate('Ministry of Commerce'), icon: 'pi pi-file', routerLink: '/category/5' },
    { label:  this.translate('commercial register'), icon: 'pi pi-file', routerLink: '/category/101' },
    {
      label: this.translate('Commercial registry services for institutions'),
      icon: 'pi pi-file',
      routerLink: '/category/102',
    },
    { label: this.translate('Saudi'), icon: 'pi pi-file', routerLink: '/category/107' },
  ];

  home: MenuItem = { icon: 'pi pi-home', routerLink: '/' };

  @Input() noredirect: boolean = false;

  staticURL = GlobalConstants.staticFilesURL;
  apilink = GlobalConstants.apiURL;
  GlobalConstants = GlobalConstants;
  pages: any[] = [];
  showing: string = '';
  currentPage: number = 1;
  totalPages: number = 0;
  totalRecords: number = 0;
  currentTypeFilter: any = 'all';
  showCommentModal: boolean = false;
  like: boolean | null = null;
  messages: Message[] = [];
  commentText: string = '';
  comments: any[] = [];

  openCommentModal(like: boolean) {
    this.like = like;
    this.showCommentModal = true;
  }

  changeToNumber(arg0: string): number {
    return Number(arg0);
  }
  checkisImg(arg0: string | undefined): any {
    if (arg0) {
      return /\.(jpg|jpeg|png|gif|svg)/.test(arg0);
    } else {
      return false;
    }
  }

  fieldTypes: any[] = []

  //Get filed types
  private async fetchFieldType(): Promise<void> {
    if (this.fieldTypes.length == 0) {
      let res = await this.dataService.postData('field-type/get/', {
        active: true,
      });
      console.log(res.data);
      if (res.error) {
        return;
      }
      this.fieldTypes = res.data
    }
  }

  private async getComments(): Promise<void> {
    let res = await this.dataService.getData('comments/data/' + this.currentview._id);

    if (res.error) {
      return;
    }
    this.comments = res.data
    console.log("COMMENTS", this.comments);
  }

  translate(key:string) {
    let translator:TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }
  sortByDepth(items: any):any {
    console.log(items)
    if (items) {
      return items.sort((a: any, b: any) => {
        return b.depth - a.depth;
      });
    } else {
      return []
    }

  }

  //Get type of the filed
  getFieldType(type: any) {

    if (type._id) {
      type = type._id
    }



    if (this.fieldTypes == undefined) {
      this.fetchFieldType().then(() => {
        var result = this.fieldTypes.find((item: any) => item._id == type)?.name;
        return result;
      })
    } else {
      var result = this.fieldTypes.find((item: any) => item._id == type)?.name
      return result;
    }

  }

  async changeView(_t29: any) {
    _t29;
    console.log('SORTING', _t29)
    _t29.fields?.sort((a: data_fields, b: data_fields) => {
      if (a.label?.priority && b.label?.priority) {
        return a.label?.priority - b.label?.priority;
      } else {
        return 0;
      }
    });

    _t29.breadcrumbs.sort((a: any, b: any) => {
      return b.depth - a.depth;
    });
    console.log('SORTING AFTER', _t29)
    _t29.breadcrumbs.forEach((item: MenuItem) => {
      console.log('ITEM BREAD', item);
      item.routerLink = '/category/' + item.id;
      if (this.checkisImg(item.icon)) {
        item.image = item.icon;
      }
    });

    console.log(_t29.fields);

    this.currentview = _t29;

    this.getComments();
    if (!this.currentview.breadcrumbs) {
      this.currentview.breadcrumbs = this.breadcrumbs;
    }
    console.log('OUDB', this.currentview)
    this.currentDataItem.emit(this.currentview);
    if (this.noredirect == false) {
      this.router.navigate([this.currentRoute], {
        queryParams: { dataId: _t29.id, first: this.first },
      });
    }

    
    //creating deep copy of old old object
    this.previousView = { ...this.currentview }
    
    //adding check
    this.currentview = {
      ...this.currentview,
      fields: this.currentview?.fields?.map((item: any) => {
        return { ...item, isChecked: false };
      }) || []
    };
    
    this.currentview.fields = await this.templateService.fetchTemplateFields(this.currentview);
    // this.fetchTemplet(this.currentview)


  }


  previousView: any



  templates: any = []
  selectedTemplete : any

 

  justinCase() {
    console.log('DATA VIEW ', this.dataView);

    var pages = Math.ceil(this.dataView.totalRecords / this.dataView.rows);

    this.pages = Array(pages)
      .fill(0)
      .map((x, i) => ('0' + String(i + 1)).slice(-2));
    //this.pages.splice(0,1)

    console.log(this.dataView.rows, this.dataView.totalRecords, pages);

    if (this.currentPage == -1) {
      this.currentPage = this.pages[0];
    }

    this.first = this.dataView.first;
    this.rows = this.dataView.rows;
    this.totalRecords = this.dataView.totalRecords;

    console.log(this.currentRoute);
  }

  // editFlag = -1;
  editFlag = false;

  @Input() data: data_item[] = [];
  @Input() current: OrganizationUnit | undefined;
  @Input() editPermission: boolean = false;
  @Output() currentDataItem: EventEmitter<data_item> = new EventEmitter();
  @Input() currentview: any = {
    id: 0,
    name: 'No services found',
    breadcrumbs: [],
  };

  data_types: any[] = [];

  sortOrder: number = 1;

  sortField: string = '';

  show_services: boolean = false;

  editData = '';



  style = {
    'background-color': 'var(--color-1)',
    '--color-1': this.colors[0],
    '--color-2': this.colors[1],
    '--color-3': this.colors[2],
    '--color-4': this.colors[3],
    '--color-5': this.colors[4],
  };

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private dataService: DataService,
    private confirmationService: ConfirmationService,
    private permissionService: PermissionHandlerService,
    private serializeService: SerializeService,
    private exportService: ExportService,
    private changeDetection: ChangeDetectorRef,
    private templateService: TemplateFieldsService

  ) { }

  print() {
    window.print();
  }
  hasPermission(unit:string,flag: string) {
    return this.permissionService.hasPermission(unit, flag);
  }

  copyLinkToClipboard() {
    this.serializeService.copyToClipboard(location.href);
    this.messages = [
      { severity: 'success', summary: this.translate('Link copied to clipboard'), detail: "Link copied to clipboard", life: 10000 },
    ]
  }

  exportExcel() {
    this.exportService.exportExcel(this.current?.data_items!);
  }

  counter(countertype: string) {
    return this.data.filter((val) => {
      if (val.type?.name == countertype) {
        return true;
      } else {
        return false;
      }
    }).length;
  }

  goToPage(maxPage: number) {
    // Validate input and navigate to the specified page

    console.log(maxPage, this.currentPage, this.currentPage >= 1 && this.currentPage <= maxPage);
    if (this.currentPage >= 1 && this.currentPage <= maxPage) {
      this.dataView.paginate({
        first: (this.currentPage - 1) * this.dataView.rows,
        rows: this.dataView.rows
      });
    }
  }
  onPageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
  }

  moveToLast(reverse: boolean) {
    if (reverse) {
      this.first = 0;
      this.rows = this.dataView.rows;
      this.currentPage = 1;
      this.dataView.paginate({ first: this.first, rows: this.rows })
    } else {
      const maxPage = Math.ceil(this.totalRecords / this.dataView.rows);
      this.first = (maxPage - 1) * this.dataView.rows;
      this.rows = this.dataView.rows;
      this.currentPage = maxPage;
      this.dataView.paginate({
        first: this.first,
        rows: this.rows
      });
    }
  }

  changePage(n: number) {
    const maxPage = Math.ceil(this.totalRecords / this.dataView.rows);
    if (n > 0 && n <= maxPage) {
      console.log(n, this.currentPage, maxPage);

      let params: any = { ...this.router.parseUrl(this.router.url).queryParams }

      params['page'] = n;

      console.log("params", params)
      
      this.router.navigate(['/search-view'], { queryParams: params }).then(() => {
        // Force a full page reload after the route change is complete
        location.reload();
      });

      this.currentPage = n;
      this.goToPage(n);
    }
  }

  ngOnChange(simpleChange: SimpleChanges) {
    if (simpleChange['editPermission']) {
      this.editPermission = simpleChange['editPermission'].currentValue;
    }
  }

  ngOnInit() {
    //Getting filed  type
    this.skeleton = true
    this.fetchFieldType()


    this.route.params.subscribe(p => {
      this.currentview = {
        name: this.translate('Please select the data'),
        id: 0
      }
      let id;
      if (p['id']) {
        id = p['id'];
      } else {
        id = this.current?.id;
      }
      this.currentRoute = '/category/' + id;
      this.route.queryParams.subscribe(async (item) => {
        var dataId = item['dataId'];
        var _first = item['first'];
        var dataIndex = this.data.find((item) => {
          return item.id == dataId;
        });

        let mymap = new Map();

        var unique = this.data.filter((el) => {
          const item = el.type;
          if (item) {
            const val = mymap.get(item?.name);
            if (val) {
              if (item && item._id && item._id < val) {
                mymap.delete(item.name);
                mymap.set(item.name, item._id);
                return true;
              } else {
                return false;
              }
            }
            mymap.set(item.name, item._id);
            return true;
          } else {
            return false;
          }
        });

        var uniquetypes: any[] = [];
        if (unique.length > 0) {
          unique.forEach((item) => {
            uniquetypes.push(item.type);
          });
        }

        this.data_types = uniquetypes;
        if (dataIndex) {
          if (!this.currentview.breadcrumbs) {
            this.currentview.breadcrumbs = this.breadcrumbs;
          }
          this.changeView(dataIndex);
        } else if (this.data[0]) {
          if (!this.currentview.breadcrumbs) {
            this.currentview.breadcrumbs = this.breadcrumbs;
          }
          this.changeView(this.data[0]);
        }
        this.updateTotalRecords();
        this.changeDetection.detectChanges();
      });

    })

    this.first = 0;
    this.rows = 10;
    this.totalRecords = this.data.length;

    if (this.totalRecords == 0) {
      this.currentview = {
        id: 0,
        name: 'No services found',
        breadcrumbs: [],
      };
    }

  }

  first: number = 0;
  rows: number = 10;


  editDataSave(arg0: string[] | string | undefined) {
    if (arg0) {
      if (Array.isArray(arg0)) {
        var editData = '';
        arg0.forEach((ele) => {
          editData = editData + ' <br> ' + ele;
        });
        this.editData = editData.slice(5);
      } else {
        this.editData = arg0;
      }
    }
  }


  resetDataview() {
    this.currentview = {
      id: 0,
      name: this.translate('Please select the data'),
      breadcrumbs: [],
    };
  }

  applyFilterGlobal($event: any, stringVal: any) {
    this.resetDataview()
    this.dataView.filter($event.target.value, stringVal);
    this.updateTotalRecords()
  }

  updateTotalRecords() {
    if (this.dataView) { this.totalRecords = this.dataView.totalRecords; }
  }

  applyTypeFilter(value: any) {
    this.resetDataview();
    if (this.currentTypeFilter != value) {
      this.currentTypeFilter = value;
    } else {
      this.currentTypeFilter = 'all';
    }

    console.log(value);
    if (this.currentTypeFilter == 'all') {
      this.dataView.filter('', 'contains');
    } else {
      this.dataView.filter(value, 'equals');
    }
    this.updateTotalRecords();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['data']) {
      this.totalRecords = this.data.length;
      this.ngOnInit();
    }
  }

  updateData() {
    
    // if no filed is checked 
    if(!this.currentview.fields.some((field:any) => field.isChecked === true) && this.currentview.name == this.previousView.name){
      return
    }

    let updateLog = {
      status: 'PENDING',
      type: 'EDIT',
      data_type: this.previousView.type._id,
      before: {
        name: this.previousView.name,
        dataview : this.previousView
      },
      after: {
        name: this.currentview.name,
        fields: this.currentview.fields

      },
      ous: this.currentview.ous,
      service_id: this.currentview._id
    }

    console.log("=4===>Testing : ", updateLog)

    this.editContent(updateLog).then(()=>{
      //set all checks to false
      const updatedFields = this.currentview.fields.map((field:any) => ({ ...field, isChecked: false }));
      this.currentview.fields = updatedFields;
      window.location.reload()
    })



  }



  async editContent(data: any) {
    try {

      console.log("===>Data uodated", data);
      let res = await this.dataService.postData('content-update/', data)

      if (res.error) {
        return
      }
      let isOuPermission: boolean = await this.permissionService.checkOUPermissionByID('CONTENT_UPDATE_LOGS', 'r', data.ous)
      if (this.permissionService.hasPermission('CONTENT_APPROVE', 'a') && isOuPermission) {

        console.log("Test Inside")

        //Approving log
        data._id = res.data._id
        data.status = 'APPROVED'
        let res2 = await this.dataService.postData('content-update/approve', data, 'PUT', false);
        if (res2.error) {
          this.messages = [
            { severity: 'error',  summary: this.translate('error'), detail: res.msg },
          ];
          return
        }
      }

      window.location.reload()
      
    } catch (error) {
      console.log(error)
    }
  }

  async deleteService() {
    let deleteLog = {
      status: 'PENDING',
      type: 'DELETE',
      data_type: this.previousView.type._id,
      before: {
        name: this.previousView.name,
        dataview : this.previousView
      },
      ous: this.currentview.ous,
      service_id: this.currentview._id
    }
    this.confirm({
      message: this.translate('Are you sure you want to do this?'),
      header: this.translate('Confirmation message'),
      icon: 'pi pi-exclamation-triangle',
      action: () =>  this.editContent(deleteLog)
    });
   
  }

  confirm(parems: any) {
    this.confirmationService.confirm({
      message: parems.message,
      header: parems.header,
      icon: parems.icon,
      acceptLabel: 'نعم',
      rejectLabel: 'لا',
      accept: () => {
        parems.action();
        return true;
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            return false;
          case ConfirmEventType.CANCEL:
            return false;
          default:
            return false;
        }
      },
    });
  }

  async makeComment() {
    if (!this.commentText || this.commentText == '') {
      return;
    }
    try {
      let data = {
        data_id: this.currentview._id,
        ou: this.current?._id,
        like: true,
        text: this.commentText
      }
      let res = await this.dataService.postData('comments/', data);
      this.showCommentModal = false
      if (res.error) {
        this.messages = [
          { severity: 'error',  summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.commentText = '';
      this.like = null;
      this.messages = [
        { severity: 'success', summary: this.translate('success'), detail: res.msg },
      ];
    } catch (error) {
      console.log(error);
    }
  }

  modalVisibilities: boolean[] = [];
  // Function to toggle modal visibility for a specific item.
  toggleModal(index: number) {
    this.modalVisibilities[index] = !this.modalVisibilities[index];
  }

  //service grt
  changeCurrentDataItem(dataItem: any, field: any, index: number) {
    field.data = dataItem
    this.toggleModal(index)
  }
}
